import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ActivityTab({ logs }) {
  const { t } = useTranslation('organization');

  const getActionIcon = (action) => {
    const icons = {
      'member.invited': '✉️',
      'member.joined': '👋',
      'member.removed': '🚫',
      'member.role_changed': '🔄',
      'organization.created': '🏢',
      'organization.updated': '✏️',
      'organization.deleted': '🗑️',
      'invitation.created': '📧',
      'invitation.cancelled': '❌',
      'invitation.accepted': '✅'
    };
    return icons[action] || '📝';
  };

  const getActionDescription = (log) => {
    if (log.metadata?.description) {
      return log.metadata.description;
    }

    // Generate description from action
    switch(log.action) {
      case 'member.invited':
        return t('activity.actions.memberInvited', { email: log.metadata?.email || 'un miembro' });
      case 'member.joined':
        return t('activity.actions.memberJoined');
      case 'member.removed':
        return t('activity.actions.memberRemoved');
      case 'member.role_changed':
        return t('activity.actions.memberRoleChanged', { role: log.metadata?.newRole || 'nuevo rol' });
      case 'organization.created':
        return t('activity.actions.orgCreated');
      case 'organization.updated':
        return t('activity.actions.orgUpdated');
      case 'invitation.created':
        return t('activity.actions.invitationCreated');
      case 'invitation.cancelled':
        return t('activity.actions.invitationCancelled');
      case 'invitation.accepted':
        return t('activity.actions.invitationAccepted');
      default:
        return log.action;
    }
  };

  if (!logs || logs.length === 0) {
    return (
      <div className="activity-tab">
        <h2>{t('activity.title')}</h2>
        <div className="empty-state">
          <h3>{t('activity.emptyTitle')}</h3>
          <p>{t('activity.emptyDescription')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-tab">
      <h2>{t('activity.title')}</h2>

      <div className="audit-log">
        {logs.map((log, index) => (
          <div key={index} className="log-entry">
            <span className="log-icon">{getActionIcon(log.action)}</span>
            <div className="log-content">
              <div className="log-header">
                <strong className="log-action">{log.action}</strong>
                {log.actor && (
                  <span className="log-actor">
                    {t('activity.byActor', { email: log.actor.email || log.actor.uid })}
                  </span>
                )}
              </div>
              <p className="log-description">{getActionDescription(log)}</p>
              <span className="log-time">
                {log.timestamp
                  ? (() => {
                      try {
                        if (log.timestamp.toDate) {
                          return new Date(log.timestamp.toDate()).toLocaleString();
                        } else if (log.timestamp._seconds) {
                          return new Date(log.timestamp._seconds * 1000).toLocaleString();
                        } else {
                          return new Date(log.timestamp).toLocaleString();
                        }
                      } catch (e) {
                        return 'N/A';
                      }
                    })()
                  : 'N/A'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
